<div class="dialog">
  <div class="dialog-header">
    <div class="area-info">
      <label>{{ squareMeters | number : "1.2-2" }}</label>
      <span>square meters</span>
    </div>
    <button class="close-button" (click)="onClose()">
      <i class="ri-close-line"></i>
    </button>
  </div>

  <form [formGroup]="form">
    <div class="form-field">
      <app-input
        [alt]="true"
        label="Name"
        placeholder="Enter name"
        [touched]="form.get('name')?.touched"
        [errorMessage]="form.get('name')?.errors"
        (blur)="form.get('name')?.markAsTouched()"
        formControlName="name"
      ></app-input>
    </div>

    <div class="form-field">
      <app-input
        [alt]="true"
        label="Description"
        placeholder="Enter description"
        [touched]="form.get('description')?.touched"
        (blur)="form.get('description')?.markAsTouched()"
        formControlName="description"
        type="textarea"
        [resize]="false"
      ></app-input>
    </div>

    <div class="form-field">
      <app-input-select
        [alt]="true"
        label="Organization"
        placeholder="Select organization"
        [touched]="form.get('organizationId')?.touched"
        [errorMessage]="form.get('organizationId')?.errors"
        (blur)="form.get('organizationId')?.markAsTouched()"
        formControlName="organizationId"
        [options]="organizations"
        optionLabel="name"
        optionValue="id"
        [disabled]="organizationsLoading"
      ></app-input-select>
    </div>

    <div class="form-group">
      <label>Color</label>
      <div class="swatches">
        <div
          *ngFor="let c of colors"
          class="swatch"
          [ngStyle]="{ 'background-color': c }"
          [class.selected]="form.get('color')?.value === c"
          (click)="onColorSelect(c)"
        ></div>
      </div>
      <div
        class="error"
        *ngIf="form.get('color')?.touched && form.get('color')?.invalid"
      >
        Color is required.
      </div>
    </div>

    <div class="field">
      <p-inputSwitch formControlName="showSwimLanes"></p-inputSwitch>
      <span>Show Swim Lanes</span>
    </div>

    <div class="row" *ngIf="form.get('showSwimLanes')?.value">
      <div class="col-6">
        <app-input
          [alt]="true"
          label="Gutter Width (m)"
          placeholder="Enter gutter width (m)"
          [touched]="form.get('gutterSpacing')?.touched"
          (blur)="form.get('gutterSpacing')?.markAsTouched()"
          formControlName="gutterSpacing"
          type="number"
        ></app-input>
      </div>
      <div class="col-6">
        <app-input
          [alt]="true"
          label="Line Width (m)"
          placeholder="Enter line width (m)"
          [touched]="form.get('lineWidth')?.touched"
          (blur)="form.get('lineWidth')?.markAsTouched()"
          formControlName="lineWidth"
          type="number"
        ></app-input>
      </div>
    </div>

    <div *ngIf="form.get('showSwimLanes')?.value" class="swim-lanes">
      <div class="form-group">
        <label style="margin-bottom: 10px" for="rotationDegrees"
          >Rotation (degrees)</label
        >
        <p-slider
          formControlName="rotationDegrees"
          [min]="0"
          [max]="360"
          [step]="1"
        ></p-slider>
        <span style="margin-top: 10px; display: block"
          >{{ form.get("rotationDegrees")?.value }}°</span
        >
      </div>
    </div>

    <div class="error" *ngIf="error">
      {{ error }}
    </div>

    <div class="actions">
      <button pButton type="button" (click)="onSave()">Save</button>
    </div>
  </form>
</div>
